module.exports = __webpack_public_path__ + "img/20190924154005360截图20190924145609456.c28bd0f3.jpg";